import React from 'react';
import { Redirect } from 'react-router';

const Callback:React.FC = () => {
    return <Redirect to="/" />
}

export default Callback